// app/javascript/controllers/frame_navigation_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Find all links inside the video cards
    const cardLinks = this.element.querySelectorAll("a");

    // Add data-turbo-frame="_top" to each link
    cardLinks.forEach((link) => {
      link.setAttribute("data-turbo-frame", "_top");
    });
  }
}
